import { Component, OnInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { commonService } from "../../service/common.service";
//import * as jspdf from 'jspdf'; 
//import * as html2canvas from 'html2canvas';


//import * as rasterizeHTML from 'rasterizehtml';


@Component({
  selector: 'app-packageinvoice',
  templateUrl: './packageinvoice.component.html',
  styleUrls: ['./packageinvoice.component.css'],
  providers: [TestSeriesService],
})
export class PackageinvoiceComponent implements OnInit {
  @ViewChild('test') el: ElementRef;
  typetxt: any = '';
  packageList: any = [];
  totalrow: any = 0;
  notfound: any;
  isPostLoad: any = false;
  msg: any = '';
  isRemaningForum: any;
  postId: any = 0;
  ngload: any;
  userData: any;
  filter: any;
  noMoreResults: any;
  isError = false;
  siteUrl = this.global.websiteUrl;
  paperList: any = [];
  streambox: any = [{ id: '' }];
  isMyPackage = false;
  streamText: any = '';
  loggedinUserId: any = 0;
  userId = 0;
  invoiceId = 0;


  constructor(private _ngZone: NgZone, private testseriesservice: TestSeriesService, private router: Router, private route: ActivatedRoute, private global: Globals, private commonService: commonService) {


  }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.invoiceId = parseInt(atob(params['id']));
        if (isNaN(this.invoiceId)) {
          this.invoiceId = 0;
        }

        this.userId = this.commonService.user.id;
        this.userData = this.commonService.user;
        this.ngload = true;
        this.packageList = [];
        let filter = {};
        filter = { limit: 10 };
        this.getMyPackageList(filter);

      }
    });

    //for direct download
    this.route.queryParams.subscribe((params: Params) => {
      if (params['type'] == 'invoice' && params['type2']) {

        this.invoiceId = parseInt((params['id']));
        if (isNaN(this.invoiceId)) {
          this.invoiceId = 0;
        }
        this.userId = this.commonService.user.id;
        this.userData = this.commonService.user;
        this.packageList = [];
        let filter = {};
        filter = { limit: 10 };
        this.getMyPackageList(filter);
      }
    });


  }

  getMyPackageList(obj) {
    obj['orderby'] = "id";
    obj['offset'] = this.packageList.length ? this.packageList.length : 0;
    obj['userId'] = this.userId;
    //obj['Stype'] = 9;  
    obj['invoiceId'] = this.invoiceId;

    this.testseriesservice.generateinvoice(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.length > 0) {
          this.packageList = data.results[0];

          /*for(let mypackagedata of data.results.rows){ 
            if(mypackagedata.orderItem) { 
              finaldata.push(mypackagedata.orderItem.testSery);
            }
          }  */
          //if(obj['invtype']=='invoice'){
          //this.captureScreen();
          //}

          this.isPostLoad = false;
        } else {

          this.packageList = [];
          console.log('cccccc', this.noMoreResults);
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.msg = "internal server error!";
    });
  }

  profileImage(img) {
    let photo = img;
    if (photo == '') {
      photo = this.userData.photo;
    } if (!photo) {
      photo = "avatar.png";
    }
    let res = this.global.profileUrl + photo;
    return res;
  }


  printpdf() {
    window.print();
  }

  signatureImage(img) {
    let res = this.global.profileUrl + this.userData.img;
    return res;
  }

  /* 
 captureScreen()
 {
   var elementToPrint = document.getElementById('contentToConvert');
   const pdf = new jspdf('p', 'pt', 'a4');
   pdf.setFont("times");
   pdf.setFontStyle("normal");
   pdf.addHTML(elementToPrint, () => {
     pdf.save('web.pdf');
   })
 }*/

  captureScreen() {
    /* this._ngZone.runOutsideAngular(() => {
     var elementToPrint = document.getElementById('contentToConvert');
     html2canvas(elementToPrint,{useCORS: true}).then(canvas => {
     const pdf = new jspdf('p', 'pt', [canvas.width, canvas.height],true);
     //pdf.internal.scaleFactor = 1.55;
     var imgData  = canvas.toDataURL("image/jpeg", 1.0);
     //pdf.addImage(imgData,'JPEG',25,25,canvas.width-50, canvas.height-50); good quality
     pdf.addImage(imgData,'JPEG',25,25,canvas.width-50, canvas.height-50,'','SLOW');
     // pdf.addHTML(elementToPrint, () => {
     //   pdf.save('web.pdf');
     // })
     //pdf.save('web.pdf');
     var abc = pdf.output('blob');
     console.log(abc);
   },()=>console.log('rejected'))
     });*/
  }

  getgstVal(per, val) {
    return Number(parseFloat(per) * parseFloat(val) / 100).toFixed(2);
  }
  getTotalSum(actual, gst) {
    let gstAmt: any;
    gstAmt = parseFloat(gst) * parseFloat(actual) / 100;

    return Number(parseFloat(actual) + parseFloat(gstAmt)).toFixed(2);
  }



}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/packageinvoice/packageinvoice.component.ts